import { Link } from "react-router-dom";
import { Button } from "../../ui/button";

export default function ActionBar({
  isRecentSummaryView,
  onBack,
  handleDownloadPDF,
}) {
  return (
    <div className="flex flex-col min-[460px]:flex-row items-center justify-between gap-4 sm:gap-6 w-full">
      {/* Back Button */}
      <Button
        variant="outline"
        className="rounded-full px-5 sm:px-6 py-3 sm:py-5 text-sm sm:text-base bg-transparent border-[#005787]/30 shadow-md sm:shadow-lg text-[#005787] w-full sm:w-auto flex items-center justify-center"
        asChild
      >
        {isRecentSummaryView ? (
          <button
            type="button"
            onClick={onBack}
            className="flex items-center justify-center"
          >
            Back
          </button>
        ) : (
          <Link to="/reception" className="flex items-center justify-center">
            <span className="mr-2 inline-flex">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                className="text-primary"
                aria-hidden="true"
              >
                <path
                  d="M15 18l-6-6 6-6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            Back to Dashboard
          </Link>
        )}
      </Button>

      {/* Download Link */}
      <button
        type="button"
        onClick={handleDownloadPDF}
        className="inline-flex items-center justify-center gap-2 text-sm sm:text-base text-[#005787] font-medium hover:text-[#00496e] transition-colors w-full sm:w-auto cursor-pointer"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M12 3v12m0 0l4-4m-4 4l-4-4M4 21h16"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Download File
      </button>
    </div>
  );
}
